<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="isVisibleAccountDrawer" [nzTitle]="accountDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <ng-container *nzDrawerContent>
        <form nz-form [formGroup]="_fS.accountForm">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                <div class="upload">
                    <nz-avatar nzIcon="user" (click)="file.click()" (change)="onFileChanged($event)" [nzSize]="94"
                        [nzSrc]="this.uploadResult ? this.uploadResult : null">
                    </nz-avatar>
                    <div class="pl-15" nzMultiple="false" (click)="file.click()" (change)="onFileChanged($event)">
                        <button nz-button nzMultiple="false" [nzLoading]="isLoadingUpload" class="update-logo-btn">
                            <i nz-icon nzType="camera" nzTheme="outline"></i>
                            Add/Update Logo
                        </button>
                    </div>
                    <input autocomplete="off" type="file" (change)="onFileChanged($event)" #file hidden
                        nzTooltipTitle="prompt text" multiple (click)="Onclick($event)" />
                    <a *ngIf="this.uploadResult" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete the logo?" nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="removeLogo()"><img src="../../../../assets/images/delete.png"
                            class="delete-File ml-1" />
                    </a>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="accountNameError">
                            <label class="label-text required">{{this.accountName}}</label>
                            <input class="input-group" nz-input formControlName="accountName" pattern="^(?!\s+$).+"
                                (keypress)="_cS.checkAlphabetsWithSpaceCommaNumbers($event)" minlength="2"
                                maxlength="100" />
                            <ng-template #accountNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter account name
                                </ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Account
                                    {{validationMessage.minlength}}
                                </ng-container>
                                <ng-container *ngIf="control.hasError('pattern')">Please enter agency
                                    name</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <ng-container *ngIf="SelectedAccountTab != 1">
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="address1Error">
                                <label class="label-text required">Address 1</label>
                                <input class="input-group" nz-input formControlName="address1" minlength="2"
                                    maxlength="100" />
                                <ng-template #address1Error let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter address
                                        1</ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Address
                                        {{validationMessage.minlength}}
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                        <div (click)="addLines()">
                            <span nz-icon nzType="down" nzTheme="outline"></span><label>Add lines</label>
                        </div>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text">Address 2</label>
                                <input class="input-group" nz-input formControlName="address2" minlength="2"
                                    maxlength="100" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="24" *ngIf="LineStreetAddress">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="streetAError">
                                <label class="label-text required">Street address</label>
                                <textarea type="text"
                                    pattern="^[A-Z-a-z0-9,./#@'?^*%$&!;:-_()+=&quot;{}|\n\s][A-Z-a-z0-9 ,./#@'?^*%$&!;:-_()+=&quot;{}|\s\r\n]{1,150}$"
                                    class="input-group" nz-input formControlName="address1" maxlength="1000"
                                    minlength="2"></textarea>
                                <ng-template #streetAError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter street address
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('pattern')">Street address
                                        {{validationMessage.minlength}}</ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="12" nzSm="6" nzMd="6" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="citytownError">
                                <label class="label-text required">City/Town</label>
                                <input class="input-group" nz-input formControlName="city" />
                                <ng-template #citytownError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter city/town
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('pattern')">Enter valid city/town
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="12" nzSm="6" nzMd="6" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="stateError">
                                <label class="label-text required">State</label>
                                <nz-select nzShowSearch nzPlaceHolder="Select state" [nzSize]="'default'"
                                    formControlName="state" [nzSelectOnTab]="true"
                                    (ngModelChange)="focusElement($event, zipcode)">
                                    <nz-option *ngFor="let option of listOfStates" [nzLabel]="option"
                                        [nzValue]="option"></nz-option>
                                </nz-select>
                                <ng-template #stateError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter state
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('pattern')">Enter valid state
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="12" nzSm="6" nzMd="6" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="zipcodeError">
                                <label class="label-text required">Zip code</label>
                                <input #zipcode class="input-group" nz-input formControlName="zipcode"
                                    (keypress)="_cS.checkNumbers($event)" mask="00000||00000-0000" minlength="5" />
                                <ng-template #zipcodeError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter zip code
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('pattern')">Enter valid zip code
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Zip code must contain at least 5
                                        digits
                                    </ng-container>
                                    <ng-container
                                        *ngIf="_fS.accountForm.get('zipcode').value.length > 5 && _fS.accountForm.get('zipcode').value.length < 9">Please
                                        enter valid zipcode (XXXXX-XXXX or XXXXX)
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="12" nzSm="6" nzMd="6" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="countryError">
                                <label class="label-text required">Country</label>
                                <input class="input-group" nz-input formControlName="country" pla />
                                <ng-template #countryError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter country
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </ng-container>

                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="agencyError">
                            <label class="label-text required">Agency</label>
                            <nz-select nzShowSearch nzPlaceHolder="Select agency" [nzSize]="'default'"
                                formControlName="agency" [nzSelectOnTab]="true"
                                (ngModelChange)="focusElement($event, actype)">
                                <nz-option *ngFor="let agency of listOfAgencies" [nzLabel]="agency.Name"
                                    [nzValue]="agency._id"></nz-option>
                            </nz-select>
                            <ng-template #agencyError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select agency</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="roleError">
                            <label class="label-text required">Type</label>
                            <nz-select #actype nzShowSearch nzPlaceHolder="Select type" [nzSize]="'default'"
                                formControlName="type" [nzSelectOnTab]="true">
                                <nz-option *ngFor="let option of listOfType" [nzLabel]="option.name"
                                    [nzValue]="option.name">
                                </nz-option>
                            </nz-select>
                            <ng-template #roleError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select type</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="statusError">
                            <label class="label-text required">Status</label>
                            <nz-radio-group formControlName="status">
                                <label nz-radio nzValue="1">Visible</label>
                                <label nz-radio nzValue="0">Hidden</label>
                            </nz-radio-group>
                            <ng-template #statusError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select status</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="18" nzXl="18">
                    <nz-form-item>
                        <nz-form-control>
                            <label class="label-text">Contract</label>
                            <nz-upload class="contact-upload" nzType="drag" nzAccept=".pdf"
                                [nzFileListRender]="fileListTpl" [nzBeforeUpload]="beforeUpload" nzActions=""
                                (nzChange)="handleChangeBulkUpload($event)">
                                <p class="ant-upload-drag-icon">
                                    <span nz-icon nzType="inbox" class="fs-20"></span>
                                </p>
                                <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            </nz-upload>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="contractDateError">
                            <label class="label-text" [ngClass]="uploadedContractFile ? 'required': ''">Contract
                                Date</label>
                            <nz-date-picker formControlName="contractDate" [nzAllowClear]="false"
                                [nzDisabled]="!uploadedContractFile"></nz-date-picker>
                            <ng-template #contractDateError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select contract date
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            <div nz-row>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="6">
                    <ng-template #fileListTpl let-list>
                        <ng-container *ngFor="let item of uploadedContractFiles; let i = index">
                            <p *ngIf="item" class="item-name-text">
                                <a (click)="item.fileLink ? '' : $event.preventDefault()"
                                    [ngClass]="item.fileLink ? '' : 'cl-blk cursor-default'" [href]="item?.fileLink"
                                    target="_blank">{{ item?.name }}</a>
                                <i nz-icon nzType="delete" class="fs-20 pl-15 cursor" nz-popconfirm
                                    nzPopconfirmTitle="Are you sure delete this file?" nzPopconfirmPlacement="bottom"
                                    (nzOnConfirm)="removeFile()"></i>
                            </p>
                        </ng-container>
                    </ng-template>
                </div>
            </div>
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="pt-18">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <h2 class="assignment-title">Assignment</h2>
                </div>
                <nz-radio-group formControlName="assignedTo">
                    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                            *ngFor="let role of assignmentRoles" class="pt-18">
                            <!-- Radio Button -->
                            <label nz-radio [nzValue]="role.value">{{ role.label }}</label>
                            <!-- Select Dropdown (Below Radio) -->
                            <nz-select nzPlaceHolder="Select a user" [formControlName]="'assignmentUser_' + role.key"
                                [nzShowSearch]="true" (ngModelChange)="disableEnableFromUsersList($event, role.key)"
                                nzAllowClear>
                                <nz-option *ngFor="let user of usersList" [nzValue]="user.id" [nzLabel]="user.name"
                                    [nzDisabled]="user.disabled">
                                    <!-- {{ user.name }} -->
                                </nz-option>
                            </nz-select>
                        </div>
                    </div>
                </nz-radio-group>

            </div>
        </form>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end ">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()" class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>
<nz-modal [nzWidth]="400" [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" nzCentered
    [nzVisible]="isAssignmentUserWarningModalVisible" [nzTitle]="'Default User Selection'" [nzFooter]="footerTpl1"
    (nzOnCancel)="handleCancelAssignmentUserWarningModal()">
    <ng-container *nzModalContent>
        <p class="text-center">The current default assignment has no individual selected. Do you want to continue?</p>
    </ng-container>
    <ng-template #footerTpl1>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancelAssignmentUserWarningModal()"
                class="medium-btn small-btn default-btn">No</button>
            <button nz-button nzType="primary" (click)="AddOrUpdateAccount()" class="medium-btn small-btn">Yes</button>
        </div>
    </ng-template>

</nz-modal>